<template>
	<div id="m_wdsp">

		<div class="g-ypxx">
			<center>
				<div class="videoborder">
					<video :src="videosrc" width="700" height="400"></video>
					<input class="videoup" type="file" accept="" @change="addpic($event)">
				</div>
			</center>
			<center><input @click="uploadinfor" type="button" class="g-btn" value="完成"></center>

		</div>



	</div>
</template>

<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'
	export default {
		data() {
			return {
				video: '',
				videosrc: storage.get('video'),
				uid:storage.get('userdata')
			};
		},
		methods: {
			addpic(event) {
				this.video = event.target.files[0];
				this.videosrc = window.URL.createObjectURL(this.video); //获取上传对象路径
			},
			uploadinfor(event) {
				var api = 'https://api.yopoo.cn/api/centre/editvideo'   
				event.preventDefault();
				let formData = new FormData();
				//向form表单中插入数据
				formData.append('video', this.video); //视频
				formData.append('uid', this.uid);
				let config = {
					headers: {
						//定义form表单的格式头
						'Content-Type': 'multipart/form-data'
					}
				}
				if (this.video == '') {
					this.$message({
						message: '请上传相关视频！',
						type: 'warning',
						center: true
					});
				}
				Axios.post(api, formData, config).then((res) => {
					// console.log(res.data)
					if (res.data.code == '200') {
						this.$message({
							message: res.data.msg,
							type: 'success',
							center: true
						});
						setTimeout(() => {
							location.reload()
						}, 1500); //reload页面重置表单为空
					}
					if (res.data.code == '202') {
						this.$message({
							message: res.data.msg,
							type: 'error',
							center: true
						});
					}

				}).catch((res) => {

				})
			}
		},
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/per_admin/per_modify/M_Wdsp.vue